// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    fullDateTime: {
        id: 'be.activityFeed.fullDateTime',
        defaultMessage: '{time, date, full} at {time, time, short}',
        description: 'Full date time and time stamp',
    },
});

export default messages;
